import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import MainApp from './App';

ReactDOM.render(<MainApp/>, document.getElementById('root'));